import React from 'react';
import { FILTER_PRESETS } from 'constants/filters';
import FilterPresetButton from './FilterPresetButton';

export default function VintageFilter() {
  return (
    <FilterPresetButton
      presetKey={FILTER_PRESETS.VINTAGE}
      label="Vintage"
      image="vintage"
      thumbnailClassName="bg-gradient-to-br from-amber-200 via-rose-200 to-slate-400"
    />
  );
}
